<div id="dashboard" class="flex flex-col">
  <div class="flex flex-col justify-center sm:w-auto">
    <div class="mb-8 flex flex-col justify-center sm:w-auto">
      <h4 class="flex sm:justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Your Renewal Offers</h4>
      <div class="grid grid-rows-2 sm:justify-items-center mt-2 text-gray-tricon text-xl sm:text-xl">
        <div>Below please find your renewal offer options with Tricon.</div>
        <div>Thank you for your residency with us.</div>
      </div>
    </div>
  </div>
  <div class="sm:w-auto flex justify-center">
    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-8">
      <div *ngFor="let renewal of renewals">
        <div *ngIf="!renewal.DefaultCard && renewal.PropViewCard !== undefined"
          class="my-4 flex justify-center flex-col">
          <div *ngIf="!renewal.DefaultCard">
            <img class="rounded w-full h-auto max-h-400px max-w-600px" src={{renewal.PropViewCard.thumb}}>
          </div>
          <div class="flex flex-col justify-between items-baseline border-b border-solid border-gray-400">
            <div class="flex flex-row justify-evenly text-lg">
              <div *ngIf="!renewal.DefaultCard" class="flex text-black">{{renewal.PropViewCard.beds}}<span
                  class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
              <div *ngIf="!renewal.DefaultCard" class="flex ml-1 text-black">{{renewal.PropViewCard.baths}}<span
                  class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon">|</span></div>
              <div *ngIf="!renewal.DefaultCard" class="flex ml-1 text-black">{{renewal.PropViewCard.sqft}}<span
                  class="text-gray-tricon ml-1">sqft</span></div>
            </div>
            <div *ngIf="!renewal.DefaultCard" class="text-2xl sm:text-lg pb-1">
              {{renewal.AddressLine1}} {{renewal.City}}, {{renewal.State}} {{renewal.PropViewCard.zip}}
            </div>
          </div>
          <div class="flex flex-col justify-between items-baseline pt-1 border-b border-solid border-gray-400">
            <div *ngFor="let plan of renewal.Plans" class="w-full flex text-lg">
              <div *ngIf="!renewal.DefaultCard" class="w-1/3 flex text-black">{{plan.Title}}</div>
              <div *ngIf="!renewal.DefaultCard" class="w-1/3 flex ml-1 text-black">{{plan.displayRent}}</div>
              <div *ngIf="!renewal.DefaultCard" class="w-1/3 flex ml-1 text-black">{{plan.displayTerm}}</div>
            </div>
          </div>
          <div class="flex flex-col mt-4">
            <div class="flex flex-row justify-between mb-1">
              <div class="text-2xl sm:text-lg text-gray-tricon">
                Expires:
              </div>
              <div class="text-2xl sm:text-lg font-bold">
                {{renewal.ExpirationDate}}
              </div>
            </div>
            <button *ngIf="!renewal.OfferExpired && !renewal.DefaultCard" mat-flat-button color="accent"
              class="my-4 sm:text-base" (click)="continueRenewal(renewal)">{{ renewal?.displayStatus}}</button>
            <button *ngIf="renewal.OfferExpired && !renewal.DefaultCard" mat-flat-button color="accent"
              class="my-4 sm:text-base" [disabled]="renewal.OfferExpired && !renewal.DefaultCard">{{
              renewal?.displayStatus}}</button>
          </div>
          <div *ngIf="renewal.DefaultCard" class="my-4 flex flex-col">
            <div>
              <img class="rounded w-full h-auto  max-w-500px" src="../../../assets/images/FallbackImage_House.jpg">
            </div>
            <button mat-flat-button color="accent" class="my-4 sm:text-base"
              [disabled]="lease.PropViewCard.sqft == null">NO RENEWALS</button>
          </div>
        </div>
      </div>
      <div *ngFor="let employer of employerConfirmation">
        <div class="flex p-2 justify-center h-255px w-283px border border-gray-300 shadow-xl">
          <div class="flex flex-col justify-between w-full">
            <div class="flex flex-col justify-center">
              <div *ngIf="employer.EmployerName !== null"
                class="flex justify-center text-center text-true-blue text-2xl mt-4 mb-1">{{employer.EmployerName}}
              </div>
              <div *ngIf="employer.EmployerName === null" class="flex justify-center text-true-blue text-2xl mt-4 mb-1">
                No Employer Listed</div>
              <div *ngIf="!employer.EmpAddress !== null"
                class="flex justify-center text-center flex-wrap text-base my-1">{{employer.EmpAddress}}</div>
              <div class="flex justify-center text-base mt-1">Expires: {{employer.ExpirationDate}}</div>
            </div>
            <div class="flex flex-col justify-center">
              <button *ngIf="employer.EmployerConfirmed === false" mat-flat-button color="accent"
                class="my-4 sm:text-base" (click)="confirmEmployer(employer)">CONFIRM CURRENT EMPLOYER</button>
              <button *ngIf="employer.EmployerConfirmed === true" mat-flat-button color="accent"
                class="my-4 sm:text-base" (click)="confirmEmployer(employer)">UPDATE EMPLOYER</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
